"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_1 = require("../../atoms/icons");
const styled_components_1 = __importDefault(require("styled-components"));
const isActiveElement = (activePhotos, currentWeek, currentPhotoKey) => {
    const week = activePhotos.find((photo) => photo.week === currentWeek);
    if (!week)
        return false;
    return week.photo === currentPhotoKey;
};
exports.default = (photos, onSetActiveElement, activePhotos, displayCheckIcon = true) => {
    const jsx = [];
    for (const photo in photos.photos) {
        const isLoading = !photos.photos[photo];
        const isActive = isActiveElement(activePhotos, photos.week, photo);
        const onClick = () => onSetActiveElement({ id: photos.id, week: photos.week, photo });
        jsx.push((0, jsx_runtime_1.jsxs)(Wrapper, { onClick: onClick, children: [(0, jsx_runtime_1.jsx)("img", { src: photos.photos[photo], alt: "Measurement photo" }, void 0), displayCheckIcon && !isLoading && ((0, jsx_runtime_1.jsx)("label", { htmlFor: photo, onClick: onClick, children: isActive && ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "circle", icon: ["far", "check"], color: "white", size: "xs" }, void 0)) }, void 0)), (0, jsx_runtime_1.jsx)("input", { type: "checkbox", defaultChecked: isActive, name: photo }, void 0)] }, photo));
    }
    return jsx;
};
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex: 1;
  position: relative;

  img {
    height: 100%;
    width: 100%;
  }

  label {
    align-items: center;
    background-color: ${({ theme }) => theme.colors.greyBase};
    border: 1px solid ${({ theme }) => theme.colors.greyBase};
    border-radius: 50%;
    display: flex;
    height: 1rem;
    justify-content: center;
    position: absolute;
    top: ${({ theme }) => theme.spacings.xs};
    right: ${({ theme }) => theme.spacings.xs};
    overflow: hidden;

    width: 1rem;
  }

  label:empty {
    background-color: ${({ theme }) => theme.colors.whiteBase};
  }

  input {
    display: none;
  }
`;
//# sourceMappingURL=RenderPhotos.js.map